module.exports = __webpack_public_path__ + "static/media/39.c2284d7b.jpg";